import { OVERLAY_VIEWPORT_Z_INDEX_CLASS } from "../../utils/constants.js";
import { tv } from "../../variants/tv.js";
const popoverSideValues = [
    'bottom',
    'inline-end',
    'inline-start',
    'left',
    'right',
    'top'
];
const popoverAlignValues = [
    'start',
    'center',
    'end'
];
const popoverSizesVariants = {
    sm: {
        popup: 'w-72'
    },
    md: {
        popup: 'w-96'
    },
    lg: {
        popup: 'w-[36rem]'
    },
    auto: {
        popup: 'w-auto min-w-72'
    }
};
const popoverSizes = Object.keys(popoverSizesVariants);
const popoverScrollValuesVariants = {
    none: {
        body: ''
    },
    body: {
        popup: 'h-full max-h-[calc(100dvh-40px)]',
        body: 'mb-6 px-6 pt-4',
        heading: 'border-b-1 border-neutral-6/50',
        scrollArea: 'h-[calc(100dvh-113px)]',
        content: 'gap-0'
    }
};
const popoverScrollValues = Object.keys(popoverScrollValuesVariants);
const popoverVariants = tv({
    slots: {
        trigger: 'inline-block',
        positioner: OVERLAY_VIEWPORT_Z_INDEX_CLASS,
        popup: 'flex flex-col rounded-2xl bg-[canvas] text-neutral-8 drop-shadow-overlay-md outline-none [--popup-corner-b:var(--radius-2xl,1rem)] [--popup-corner-t:var(--radius-2xl,1rem)] [-webkit-backface-visibility:hidden] [backface-visibility:hidden] [&_[data-scroll-state]]:!relative',
        drawerPopup: 'flex w-full max-w-[100vw] [transform:translateY(var(--drawer-swipe-movement-y))] flex-col rounded-t-2xl bg-[canvas] pb-[env(safe-area-inset-bottom)] text-neutral-8 shadow-overlay-md transition-[transform,scale] duration-[450ms] ease-[cubic-bezier(0.32,0.72,0,1)] outline-none [--popup-corner-b:0] [--popup-corner-t:var(--radius-2xl,1rem)] [-webkit-backface-visibility:hidden] [backface-visibility:hidden] data-[ending-style]:[transform:translateY(calc(100%+2px))] data-[ending-style]:duration-[calc(var(--drawer-swipe-strength)*400ms)] data-[nested-dialog-open]:scale-90 data-[nested-dialog-open]:shadow-none data-[nested-drawer-open]:scale-90 data-[nested-drawer-open]:shadow-none data-[nested-popover-open]:scale-90 data-[nested-popover-open]:shadow-none data-[starting-style]:[transform:translateY(calc(100%+2px))] data-[swiping]:duration-0',
        viewport: [
            'fixed inset-0 isolate flex items-end justify-center',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        popupAnimation: [
            'data-[starting-style]:opacity-0',
            'data-[ending-style]:opacity-0',
            'data-[ending-style]:translate-x-0 data-[ending-style]:translate-y-0',
            'data-[side=bottom]:data-[starting-style]:translate-y-[-10px]',
            'data-[side=top]:data-[starting-style]:translate-y-[10px]',
            'data-[side=left]:data-[starting-style]:translate-x-[-10px]',
            'data-[side=right]:data-[starting-style]:translate-x-[10px]',
            'data-[side=inline-end]:data-[starting-style]:translate-x-[10px]',
            'data-[side=inline-start]:data-[starting-style]:translate-x-[-10px]',
            'data-[side=bottom]:data-[open]:animate-scale-in-top',
            'data-[side=top]:data-[open]:animate-scale-in-bottom',
            'data-[side=left]:data-[open]:animate-scale-in-right',
            'data-[side=right]:data-[open]:animate-scale-in-left',
            'data-[side=inline-end]:data-[open]:animate-scale-in-left',
            'data-[side=inline-start]:data-[open]:animate-scale-in-right',
            'data-[side=bottom]:data-[closed]:animate-scale-out-top',
            'data-[side=top]:data-[closed]:animate-scale-out-bottom',
            'data-[side=left]:data-[closed]:animate-scale-out-right',
            'data-[side=right]:data-[closed]:animate-scale-out-left',
            'data-[side=inline-end]:data-[closed]:animate-scale-out-left',
            'data-[side=inline-start]:data-[closed]:animate-scale-out-right'
        ],
        arrow: 'data-[side=bottom]:top-[-8px] data-[side=left]:right-[-13px] data-[side=left]:rotate-90 data-[side=right]:left-[-13px] data-[side=right]:-rotate-90 data-[side=top]:bottom-[-8px] data-[side=top]:rotate-180',
        backdrop: [
            'fixed inset-0 min-h-dvh bg-neutral-13/50 transition-opacity duration-150 data-[ending-style]:opacity-0 data-[starting-style]:opacity-0',
            OVERLAY_VIEWPORT_Z_INDEX_CLASS
        ],
        content: 'relative flex flex-col',
        scrollArea: '',
        body: '',
        bodyText: 'inline-block w-full px-5 pb-5 text-body2',
        heading: 'flex w-full flex-row items-center gap-3 px-5 pt-3 pr-3 pb-3',
        headingLeft: 'flex flex-grow flex-row text-heading4',
        headingRight: '',
        headingCloseButton: '',
        headingText: 'text-heading4 font-semibold text-neutral-13',
        headingIcon: 'mr-2 text-neutral-13',
        headingCustom: 'w-full',
        footer: '',
        title: '',
        description: 'text-body2 text-neutral-10',
        close: ''
    },
    variants: {
        size: popoverSizesVariants,
        scroll: popoverScrollValuesVariants,
        customHeader: {
            true: {
                content: 'pt-0',
                heading: 'flex w-full flex-row items-center justify-between'
            }
        },
        customFooter: {
            true: {
                content: 'pb-0'
            }
        },
        customBody: {
            true: {
                content: 'gap-0',
                body: 'px-0 pt-0 pb-0'
            }
        },
        noHeading: {
            true: {
                headingCloseButton: 'absolute top-[-12px] right-[-12px]',
                bodyText: 'inline-block w-full px-5 pt-5 pb-5 text-body2',
                content: 'pt-5'
            }
        },
        stickyFooter: {
            true: {
                footer: 'sticky right-0 bottom-0 left-0'
            }
        }
    },
    compoundVariants: [
        {
            customHeader: true,
            customFooter: true,
            scroll: 'body',
            class: {
                body: 'mb-0',
                scrollArea: 'h-[calc(100dvh-90px)]'
            }
        },
        {
            customBody: false,
            scroll: 'body',
            class: {
                body: 'px-0'
            }
        },
        {
            customHeader: true,
            customBody: false,
            class: {
                body: 'pt-3'
            }
        }
    ],
    defaultVariants: {
        size: 'md',
        scroll: 'none',
        stickyFooter: false
    }
});
export { popoverAlignValues, popoverScrollValues, popoverScrollValuesVariants, popoverSideValues, popoverSizes, popoverSizesVariants, popoverVariants };
